/* WELIA Black Friday: één klok voor alle timers. Tijden staan in snippets/wb-bf-head.liquid (window.WB_BF).
   Rekent elke tik opnieuw vanaf de vaste tijden, dus vernieuwen zet niets terug. Zoekt elke tik opnieuw naar timers,
   zodat ook een opnieuw getekende winkelwagenlade meteen meeloopt. */
(function () {
  var bf = window.WB_BF;
  if (!bf) return;
  var root = document.documentElement;
  var timeout;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function put(box, sel, value) {
    var el = box.querySelector(sel);
    if (el && el.textContent !== value) el.textContent = value;
  }

  function tick() {
    clearTimeout(timeout);
    var now = Date.now();
    var phase = now < bf.start ? 'pre' : (now < bf.end ? 'live' : 'ended');
    if (root.getAttribute('data-bf-phase') !== phase) root.setAttribute('data-bf-phase', phase);
    var left = phase === 'pre' ? bf.start - now : (phase === 'live' ? bf.end - now : 0);
    var total = Math.max(0, Math.ceil(left / 1000));
    var d = Math.floor(total / 86400);
    var h = Math.floor(total % 86400 / 3600);
    var m = Math.floor(total % 3600 / 60);
    var s = total % 60;
    var timers = document.querySelectorAll('[data-bf-timer]');
    for (var i = 0; i < timers.length; i++) {
      var t = timers[i];
      put(t, '[data-bf-d]', t.classList.contains('wb-bf-timer--compact') ? String(d) : pad(d));
      put(t, '[data-bf-h]', pad(h));
      put(t, '[data-bf-m]', pad(m));
      put(t, '[data-bf-s]', pad(s));
      t.setAttribute('data-bf-days', d > 0 ? '1' : '0');
    }
    if (phase !== 'ended') timeout = setTimeout(tick, 1000 - (now % 1000) + 5);
  }

  tick();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
  window.addEventListener('pageshow', tick);
})();
